import { Injectable } from '@angular/core';
import { PdfjsService } from 'src/app/shared/services/pdfjs/pdfjs.service';

@Injectable({
  providedIn: 'root'
})
export class PdfToPngService {

  pdfjs: PdfjsService;

  constructor(pdfjs: PdfjsService) {
    this.pdfjs = pdfjs
   }

  /** Maximum time (ms) allowed for the entire PDF→PNG pipeline before aborting. */
  private static readonly PDF_PROCESSING_TIMEOUT_MS = 30_000;

  async getPngFromPdfjs(pdfBytes: ArrayBuffer, scale: number = 1, maxPages: number | null = null): Promise<string> {
    const timeoutPromise = new Promise<never>((_, reject) =>
      setTimeout(
        () => reject(new Error(`PDF processing timed out after ${PdfToPngService.PDF_PROCESSING_TIMEOUT_MS / 1000}s`)),
        PdfToPngService.PDF_PROCESSING_TIMEOUT_MS
      )
    );

    const pageRange = maxPages !== null
      ? { start: 1, max: maxPages }
      : { start: 1, max: null };

    const result = await Promise.race([
      this.pdfjs.getPdfPages(pdfBytes, pageRange),
      timeoutPromise,
    ]);

    if (result) {
      return (await Promise.race([
        this.pdfjs.stichPdfPagesToSinglePng(result[0], scale),
        timeoutPromise,
      ])).dataUrl;
    }

    return '';
  }
}
